// @ts-nocheck

import { CommonActionTypes } from '../types/actions/common';

/**
 * FIXME
 * [description]
 * @param  {[object]} entities [description]
 * @return {[type]}            [description]
 */
const receiveEntities = (entities) => ({
  type: CommonActionTypes.RECEIVE_ENTITIES,
  payload: entities,
});

export default {
  receiveEntities,
};
